import React, { useState } from "react";
import TodoList from './pages/TodoList'
import './App.css';



const App = () => {

    return (
        <div className='main'>

            <TodoList />

        </div>
    )

}

export default App;